export default __webpack_public_path__ + "static/Heart_Sounds-ee154f33abf8f1bb9707a302865881b9.png";